<template>
<div v-if="stage_key=='documents'">
    <document :stage_key="stage_key" :sort="sort" :application_id="application_id" />
</div>
<div v-else-if="stage_key=='references'">
    <reference ref="question" :stage_key="stage_key" :sort="sort" :application_id="application_id" />
</div>
<div v-else>
    <question ref="question" :stage_key="stage_key" :sort="sort" :application_id="application_id" />
</div>
</template>
<script>
import Document from './DocumentQuestion';
import Question from './QuestionComponent';
import Reference from './ReferenceQuestion';

export default {
    props: {
        stage_key: String,
        sort: [String, Number],
        application_id: [String, Number]
    },
    components: {
        Question,
        Reference,
        Document
    },
}
</script>